module.exports = __webpack_public_path__ + "static/adventure-BG-4a790d31a56c43e51260f0f4cde6ff3d.jpg";